// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .container.menu-back{
    position: fixed;
    top: 1rem;
    left: 1rem;
  }
  
  .navigation__checkbox {
      display: none;
  }
  
  .navigation__button {
      position: fixed;
      top: 1.5rem;
      right: 1.5rem;
      height: 5rem;
      width: 5rem;
      text-align: center;
      background: transparent;
      /* border-radius: 50%; */
      z-index: 300;
      box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.2);
      cursor: pointer;
  }


 .navigation__nav ul {
    display: block;
    overflow-y: auto;
    max-height: 80vh;
    padding: 0px 140px 0px 140px;
}
.language-dropdown {
    width: fit-content !important;
}
.navigation__nav ul li {
  margin-bottom: 20px;
  padding-left: 80px;
  border-bottom: 1px solid #6C757D;
  width:100%;
  text-align: left !important;
  font-family: "Poppins" !important;
    color: #919191;
    font-size: 35px !important;
}
.navigation__nav ul li:last-child {
    border-bottom: none;
}

.navigation__nav ul li a {
  position: relative;
  bottom: 10px;
  width:100%;
  line-height: 55px;
  font-weight: 400;
  transition: all 0.8s ease ;
} 
.navigation__nav ul li.active{
    color: #FFF;
}
.navigation__nav ul li a:hover {
    color: white;
}

.social-icons  {
    /* display: flex;
    align-items: center; */
    margin-bottom: 20px ; 
}
.navigation__list .arrow{
    position: relative;
    bottom: 10px;
    cursor: pointer;
}

.social-icons svg{
    position: relative;
    width: 38px;
    margin: 0px 10px 0px 10px;
    top: 8px;
    
    
}
.social-icons svg path{
    fill: #919191;
    transition: fill 0.8s ease;
}
.social-icons svg:hover path{
    fill: #F9F39C ;

  }
.social-txt{
    padding-right: 60px ; 
    color: #6C757D;
}
  
  @media screen  and (min-width: 768px) {
      .navigation__button {
          top: 4rem;
          right: 4rem;
          height: 7rem;
          width: 7rem;
      }
  }
  
  .navigation__background {
      position: fixed;
      top: 0;
      right: 0;
      height: 100%;
      width: 0;
      /* border-radius: 50%; */
      background: #000000;
      background-size: cover;
      background-position: center;
      z-index: 100;
      transition: all 1s cubic-bezier(0.86, 0, 0.07, 1);
  }
  
  @media screen and (min-width: 768px) {
      .navigation__background {
          top: 0;
          right: 0;
          width: 0;
      }
  }
  
  .navigation__nav {
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      opacity: 0;
      width: 0;
      visibility: hidden;
      z-index: 200;
      transition: all 800ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  
  .navigation__list {
      /*@include center;*/
      /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
      list-style: none; */
      list-style: none; 
      padding: 20px;
      padding-top: 120px;
  }
  
  /* .navigation__item {
      margin: 1rem;
  }
   */
  .navigation__link:link,
  .navigation__link:visited {
      display: inline-block;
      padding: 1rem 2rem;
      text-transform: uppercase;
      color: #f4f4f4;
      font-size: 2.4rem;
      text-decoration: none;
      transition: all .2s;
  }
  
  @media(min-width: 768px) {
      .navigation__link:link,
      .navigation__link:visited {
          font-size: 3.8rem;
      }
  }
  
  .navigation__link span {
      margin-right: 1.5rem;
      display: inline-block;
  }
  
  .navigation__link:hover {
      color: #C1D0D0;
      transform: scale(1.1);
  }
  
  .navigation__checkbox:checked~.navigation__background {
      transform: scale(80);
      width: 100%;
      height: 100%;
  }
  
  .navigation__checkbox:checked~.navigation__nav {
      width: 100%;
      visibility: visible;
      opacity: 1;
  }
  
  .navigation__icon {
  
      position: relative;
      margin-top: 2.5rem;
  }
  
  @media screen and (min-width: 768px) {
      .navigation__icon {
          margin-top: 3.5rem;
      }
  }
  
  .navigation__icon,
  .navigation__icon::before,
  .navigation__icon::after {
      display: inline-block;
      width: 2.2rem;
      height: 2px;
      background-color: #4A676A;
  }
  
  @media (min-width: 768px) {
      .navigation__icon,
      .navigation__icon::before,
      .navigation__icon::after {
          width: 3rem;
      }
  }
  
  .navigation__icon::before,
  .navigation__icon::after {
      content: '';
      position: absolute;
      left: 0;
      transition: all 200ms;
  }
  
  .navigation__icon::before {
      top: -.8rem;
  }
  
  .navigation__icon::after {
      top: .8rem;
  }
  
  .navigation__button:hover .navigation__icon::before {
      top: -1rem;
  }
  
  .navigation__button:hover .navigation__icon::after {
      top: 1rem;
  }
  
  .navigation__checkbox:checked+.navigation__button .navigation__icon {
      background-color: transparent;
  }
  
  .navigation__checkbox:checked+.navigation__button .navigation__icon::before {
      top: 0;
      transform: rotate(135deg);
  }
  
  .navigation__checkbox:checked+.navigation__button .navigation__icon::after {
      top: 0;
      transform: rotate(-135deg);
  }
  
  
  
  /*-----------------------*/
  #by {
    font-family: 'Arima Madurai', cursive;
    color: #4A676A;
    font-size: 10px;
    position: absolute;
    top: 22%;
    right: 2.5%; 
  }
  
  /*
  light-blue: #C1D0D0;
  dark-blue: #4A676A;
  cream: #FFEAA5;
  yellow: #FFB037;
  */




@media (max-width: 992px) {

/* } */

/* @media (max-width: 768px) { */

    
.app-content{
    position: relative;
    top: -100px;
    overflow-x: hidden;
}

}

@media (max-width: 576px) {
    .app-content{
        position: relative;
        /* margin-top: -40px; */
        top: -75px;
        overflow-x: hidden;
    }
    .navigation__nav ul{
        padding: 100px 10px 0px 10px;
    }
    .navigation__nav ul li {
        padding-left: 30px;
        font-size: 20px !important;
        
    }
    
    .navigation__list .arrow img{
        height: 30px;
    }
    .social-icn{
        display: flex;
        align-items: flex-start;
        position: relative;
        top: 10px;
    }
    .navigation__nav ul li a{
        line-height: 38px;
        width: 45px;
    }

    .social-icons svg{
        margin: 0;
        width: 30px;
    }
    
}




@media (min-width:768px) and (max-width:992px) {
    .navigation__nav ul{
        padding: 150px 80px 0px 80px;
    }
    .navigation__nav ul li {
        padding-left: 60px;
    }
    .social-icn{
        display: flex;
    }
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Layout.css"],"names":[],"mappings":"EAAE;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,eAAe;MACf,WAAW;MACX,aAAa;MACb,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,uBAAuB;MACvB,wBAAwB;MACxB,YAAY;MACZ,0CAA0C;MAC1C,eAAe;EACnB;;;CAGD;IACG,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,2BAA2B;EAC3B,iCAAiC;IAC/B,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA;IACI;0BACsB;IACtB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,QAAQ;;;AAGZ;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,cAAc;;EAEhB;AACF;IACI,oBAAoB;IACpB,cAAc;AAClB;;EAEE;MACI;UACI,SAAS;UACT,WAAW;UACX,YAAY;UACZ,WAAW;MACf;EACJ;;EAEA;MACI,eAAe;MACf,MAAM;MACN,QAAQ;MACR,YAAY;MACZ,QAAQ;MACR,wBAAwB;MACxB,mBAAmB;MACnB,sBAAsB;MACtB,2BAA2B;MAC3B,YAAY;MACZ,iDAAiD;EACrD;;EAEA;MACI;UACI,MAAM;UACN,QAAQ;UACR,QAAQ;MACZ;EACJ;;EAEA;MACI,eAAe;MACf,MAAM;MACN,OAAO;MACP,aAAa;MACb,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,4DAA4D;EAChE;;EAEA;MACI,mBAAmB;MACnB;;;;;;yBAMmB;MACnB,gBAAgB;MAChB,aAAa;MACb,kBAAkB;EACtB;;EAEA;;;IAGE;EACF;;MAEI,qBAAqB;MACrB,kBAAkB;MAClB,yBAAyB;MACzB,cAAc;MACd,iBAAiB;MACjB,qBAAqB;MACrB,mBAAmB;EACvB;;EAEA;MACI;;UAEI,iBAAiB;MACrB;EACJ;;EAEA;MACI,oBAAoB;MACpB,qBAAqB;EACzB;;EAEA;MACI,cAAc;MACd,qBAAqB;EACzB;;EAEA;MACI,oBAAoB;MACpB,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,WAAW;MACX,mBAAmB;MACnB,UAAU;EACd;;EAEA;;MAEI,kBAAkB;MAClB,kBAAkB;EACtB;;EAEA;MACI;UACI,kBAAkB;MACtB;EACJ;;EAEA;;;MAGI,qBAAqB;MACrB,aAAa;MACb,WAAW;MACX,yBAAyB;EAC7B;;EAEA;MACI;;;UAGI,WAAW;MACf;EACJ;;EAEA;;MAEI,WAAW;MACX,kBAAkB;MAClB,OAAO;MACP,qBAAqB;EACzB;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,UAAU;EACd;;EAEA;MACI,UAAU;EACd;;EAEA;MACI,SAAS;EACb;;EAEA;MACI,6BAA6B;EACjC;;EAEA;MACI,MAAM;MACN,yBAAyB;EAC7B;;EAEA;MACI,MAAM;MACN,0BAA0B;EAC9B;;;;EAIA,0BAA0B;EAC1B;IACE,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;;;;;GAKC;;;;;AAKH;;AAEA,MAAM;;AAEN,gCAAgC;;;AAGhC;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;QACvB,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,kBAAkB;QAClB,0BAA0B;;IAE9B;;IAEA;QACI,YAAY;IAChB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,kBAAkB;QAClB,SAAS;IACb;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;AAEJ;;;;;AAKA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["  .container.menu-back{\r\n    position: fixed;\r\n    top: 1rem;\r\n    left: 1rem;\r\n  }\r\n  \r\n  .navigation__checkbox {\r\n      display: none;\r\n  }\r\n  \r\n  .navigation__button {\r\n      position: fixed;\r\n      top: 1.5rem;\r\n      right: 1.5rem;\r\n      height: 5rem;\r\n      width: 5rem;\r\n      text-align: center;\r\n      background: transparent;\r\n      /* border-radius: 50%; */\r\n      z-index: 300;\r\n      box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.2);\r\n      cursor: pointer;\r\n  }\r\n\r\n\r\n .navigation__nav ul {\r\n    display: block;\r\n    overflow-y: auto;\r\n    max-height: 80vh;\r\n    padding: 0px 140px 0px 140px;\r\n}\r\n.language-dropdown {\r\n    width: fit-content !important;\r\n}\r\n.navigation__nav ul li {\r\n  margin-bottom: 20px;\r\n  padding-left: 80px;\r\n  border-bottom: 1px solid #6C757D;\r\n  width:100%;\r\n  text-align: left !important;\r\n  font-family: \"Poppins\" !important;\r\n    color: #919191;\r\n    font-size: 35px !important;\r\n}\r\n.navigation__nav ul li:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.navigation__nav ul li a {\r\n  position: relative;\r\n  bottom: 10px;\r\n  width:100%;\r\n  line-height: 55px;\r\n  font-weight: 400;\r\n  transition: all 0.8s ease ;\r\n} \r\n.navigation__nav ul li.active{\r\n    color: #FFF;\r\n}\r\n.navigation__nav ul li a:hover {\r\n    color: white;\r\n}\r\n\r\n.social-icons  {\r\n    /* display: flex;\r\n    align-items: center; */\r\n    margin-bottom: 20px ; \r\n}\r\n.navigation__list .arrow{\r\n    position: relative;\r\n    bottom: 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.social-icons svg{\r\n    position: relative;\r\n    width: 38px;\r\n    margin: 0px 10px 0px 10px;\r\n    top: 8px;\r\n    \r\n    \r\n}\r\n.social-icons svg path{\r\n    fill: #919191;\r\n    transition: fill 0.8s ease;\r\n}\r\n.social-icons svg:hover path{\r\n    fill: #F9F39C ;\r\n\r\n  }\r\n.social-txt{\r\n    padding-right: 60px ; \r\n    color: #6C757D;\r\n}\r\n  \r\n  @media screen  and (min-width: 768px) {\r\n      .navigation__button {\r\n          top: 4rem;\r\n          right: 4rem;\r\n          height: 7rem;\r\n          width: 7rem;\r\n      }\r\n  }\r\n  \r\n  .navigation__background {\r\n      position: fixed;\r\n      top: 0;\r\n      right: 0;\r\n      height: 100%;\r\n      width: 0;\r\n      /* border-radius: 50%; */\r\n      background: #000000;\r\n      background-size: cover;\r\n      background-position: center;\r\n      z-index: 100;\r\n      transition: all 1s cubic-bezier(0.86, 0, 0.07, 1);\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n      .navigation__background {\r\n          top: 0;\r\n          right: 0;\r\n          width: 0;\r\n      }\r\n  }\r\n  \r\n  .navigation__nav {\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      height: 100vh;\r\n      opacity: 0;\r\n      width: 0;\r\n      visibility: hidden;\r\n      z-index: 200;\r\n      transition: all 800ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  }\r\n  \r\n  .navigation__list {\r\n      /*@include center;*/\r\n      /* position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n      text-align: center;\r\n      width: 100%;\r\n      list-style: none; */\r\n      list-style: none; \r\n      padding: 20px;\r\n      padding-top: 120px;\r\n  }\r\n  \r\n  /* .navigation__item {\r\n      margin: 1rem;\r\n  }\r\n   */\r\n  .navigation__link:link,\r\n  .navigation__link:visited {\r\n      display: inline-block;\r\n      padding: 1rem 2rem;\r\n      text-transform: uppercase;\r\n      color: #f4f4f4;\r\n      font-size: 2.4rem;\r\n      text-decoration: none;\r\n      transition: all .2s;\r\n  }\r\n  \r\n  @media(min-width: 768px) {\r\n      .navigation__link:link,\r\n      .navigation__link:visited {\r\n          font-size: 3.8rem;\r\n      }\r\n  }\r\n  \r\n  .navigation__link span {\r\n      margin-right: 1.5rem;\r\n      display: inline-block;\r\n  }\r\n  \r\n  .navigation__link:hover {\r\n      color: #C1D0D0;\r\n      transform: scale(1.1);\r\n  }\r\n  \r\n  .navigation__checkbox:checked~.navigation__background {\r\n      transform: scale(80);\r\n      width: 100%;\r\n      height: 100%;\r\n  }\r\n  \r\n  .navigation__checkbox:checked~.navigation__nav {\r\n      width: 100%;\r\n      visibility: visible;\r\n      opacity: 1;\r\n  }\r\n  \r\n  .navigation__icon {\r\n  \r\n      position: relative;\r\n      margin-top: 2.5rem;\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n      .navigation__icon {\r\n          margin-top: 3.5rem;\r\n      }\r\n  }\r\n  \r\n  .navigation__icon,\r\n  .navigation__icon::before,\r\n  .navigation__icon::after {\r\n      display: inline-block;\r\n      width: 2.2rem;\r\n      height: 2px;\r\n      background-color: #4A676A;\r\n  }\r\n  \r\n  @media (min-width: 768px) {\r\n      .navigation__icon,\r\n      .navigation__icon::before,\r\n      .navigation__icon::after {\r\n          width: 3rem;\r\n      }\r\n  }\r\n  \r\n  .navigation__icon::before,\r\n  .navigation__icon::after {\r\n      content: '';\r\n      position: absolute;\r\n      left: 0;\r\n      transition: all 200ms;\r\n  }\r\n  \r\n  .navigation__icon::before {\r\n      top: -.8rem;\r\n  }\r\n  \r\n  .navigation__icon::after {\r\n      top: .8rem;\r\n  }\r\n  \r\n  .navigation__button:hover .navigation__icon::before {\r\n      top: -1rem;\r\n  }\r\n  \r\n  .navigation__button:hover .navigation__icon::after {\r\n      top: 1rem;\r\n  }\r\n  \r\n  .navigation__checkbox:checked+.navigation__button .navigation__icon {\r\n      background-color: transparent;\r\n  }\r\n  \r\n  .navigation__checkbox:checked+.navigation__button .navigation__icon::before {\r\n      top: 0;\r\n      transform: rotate(135deg);\r\n  }\r\n  \r\n  .navigation__checkbox:checked+.navigation__button .navigation__icon::after {\r\n      top: 0;\r\n      transform: rotate(-135deg);\r\n  }\r\n  \r\n  \r\n  \r\n  /*-----------------------*/\r\n  #by {\r\n    font-family: 'Arima Madurai', cursive;\r\n    color: #4A676A;\r\n    font-size: 10px;\r\n    position: absolute;\r\n    top: 22%;\r\n    right: 2.5%; \r\n  }\r\n  \r\n  /*\r\n  light-blue: #C1D0D0;\r\n  dark-blue: #4A676A;\r\n  cream: #FFEAA5;\r\n  yellow: #FFB037;\r\n  */\r\n\r\n\r\n\r\n\r\n@media (max-width: 992px) {\r\n\r\n/* } */\r\n\r\n/* @media (max-width: 768px) { */\r\n\r\n    \r\n.app-content{\r\n    position: relative;\r\n    top: -100px;\r\n    overflow-x: hidden;\r\n}\r\n\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .app-content{\r\n        position: relative;\r\n        /* margin-top: -40px; */\r\n        top: -75px;\r\n        overflow-x: hidden;\r\n    }\r\n    .navigation__nav ul{\r\n        padding: 100px 10px 0px 10px;\r\n    }\r\n    .navigation__nav ul li {\r\n        padding-left: 30px;\r\n        font-size: 20px !important;\r\n        \r\n    }\r\n    \r\n    .navigation__list .arrow img{\r\n        height: 30px;\r\n    }\r\n    .social-icn{\r\n        display: flex;\r\n        align-items: flex-start;\r\n        position: relative;\r\n        top: 10px;\r\n    }\r\n    .navigation__nav ul li a{\r\n        line-height: 38px;\r\n        width: 45px;\r\n    }\r\n\r\n    .social-icons svg{\r\n        margin: 0;\r\n        width: 30px;\r\n    }\r\n    \r\n}\r\n\r\n\r\n\r\n\r\n@media (min-width:768px) and (max-width:992px) {\r\n    .navigation__nav ul{\r\n        padding: 150px 80px 0px 80px;\r\n    }\r\n    .navigation__nav ul li {\r\n        padding-left: 60px;\r\n    }\r\n    .social-icn{\r\n        display: flex;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
